<div class="auth-status">
  <app-loading></app-loading>
  <div *ngIf="longLoading">
    <p class="auth-status-text">{{ "login.nothing" | translate }}</p>
    <a class="auth-status-link" [routerLink]="['/login']">{{ "login.again" | translate }}</a>
  </div>
</div>
